import * as React from "react"
import type { SVGProps } from "react"
const SvgContent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 17a1 1 0 0 1-.71-.29A1 1 0 0 1 3 16V8q0-.42.29-.71.29-.3.71-.29h8q.42 0 .71.29.3.29.29.71v8q0 .42-.29.71-.29.3-.71.29zm1-2h6V9H5zM4 5a1 1 0 0 1-.71-.29A1 1 0 0 1 3 4q0-.42.29-.71.29-.3.71-.29h16q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29zm12 4a1 1 0 0 1-.71-.29A1 1 0 0 1 15 8q0-.42.29-.71.29-.3.71-.29h4q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29zm0 4a1 1 0 0 1-.71-.29A1 1 0 0 1 15 12q0-.42.29-.71.29-.3.71-.29h4q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29zm0 4a1 1 0 0 1-.71-.29A1 1 0 0 1 15 16q0-.42.29-.71.29-.3.71-.29h4q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29zM4 21a1 1 0 0 1-.71-.29A1 1 0 0 1 3 20q0-.42.29-.71.29-.3.71-.29h16q.42 0 .71.29.3.29.29.71 0 .42-.29.71-.29.3-.71.29z" />
  </svg>
)
export default SvgContent
